import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            dayFilter: [], 
            typeFilter: [], 
            langFilter: [], 
            yearFilter: [], 
            monthFilter: [], 
            sourceFilter: [], 
            subCatFilter: [], 
            filterOption: [], 
            mainCatFilter: [], 
            channelFilter: [], 
            keywordFilter: [], 
            publisherFilter: [], 
            sentimentFilter: [], 
            detailCatFilter: [],
            irrelativeFilter: []
        }
    },
    getters,
    actions,
    mutations
}